import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormGroupDirective } from '@angular/forms';
import { MyErrorStateMatcher } from '../../../../app/core/_base/crud';
import { RegisterMachineHttpService } from '../../../../app/core/register-machine/_services/register-machine-http.service';
import { MatSnackBar } from '@angular/material';
import { FilterParams } from '../../../core/filter-options/filter-options.service';
import { MixpanelService } from '../../../../app/services/mixpanel.service';

@Component({
  selector: 'kt-register-machine',
  templateUrl: './register-machine.component.html',
  styleUrls: ['./register-machine.component.css']
})
export class RegisterMachineComponent implements OnInit {

	// @ViewChild('form', {static: true}) form;
	@ViewChild(FormGroupDirective, {static: false}) formDirective: FormGroupDirective;

  constructor(
    private _snackBar: MatSnackBar,
    private http: RegisterMachineHttpService,
    private cdr: ChangeDetectorRef,
    private mixpanelService: MixpanelService
  ) { }

  serialNo;
  azSerialNo;
  screenPartNo;
  distiName;
  distiId;

  showFields = false;
  initialFilterValues: {
    distributorIds?: (string | number)[];
  } = {};

  ngOnInit() {
    // Track page view
    this.mixpanelService.track(this.mixpanelService.PAGE_VIEW);
  }

  check(){

	this.distiName = null;
	this.distiId = null;
	this.initialFilterValues = {};

	if(this.serialNo && this.serialNo.length >= 10){
		this.http.getRegistration(this.serialNo)
		.subscribe((mac: any[]) => {
			console.log("Machine Details:",mac);
			if(mac.length){
				this.showFields = true;
				this.azSerialNo = mac[0].azSerialNo;
				this.screenPartNo = mac[0].screenPartNo;
				this.distiName = mac[0].name;
				this.distiId = mac[0].disti_id;

				// Set initial values for hierarchical filters
				if (this.distiId) {
					this.initialFilterValues = {
						distributorIds: [this.distiId]
					};
				}
			}else{
				this.showFields = false;
				this.snackBar("Unable to locate the serial number. Make sure it is registered.", 5000);

			}
			this.cdr.detectChanges();

		});
	}else{
		this.snackBar("Please provide a valid serial number.", 5000);
	}
  }

	onFiltersChange(params: FilterParams): void {
		if (!this.serialNo) {
			this.snackBar("Please provide the serial no", 0);
			return;
		}

		if (params.disti_id) {
			const distiId = Array.isArray(params.disti_id) ? params.disti_id[0] : params.disti_id;
			this.distiId = distiId;
			// The hierarchical-filters component handles display, but we need to get the name
			// For now, set a placeholder that will be updated when the component loads
			this.distiName = 'Selected';
			this.cdr.detectChanges();
		}
	}



  onSubmited() {
	let obj = {
		serial_no: this.serialNo,
		azSerialNo: this.azSerialNo || null,
		screenPartNo: this.screenPartNo || null,
		distiId: this.distiId
	}

	console.log(obj);
	this.http.updateRegistration(obj)
	.subscribe(resp => {
		console.log(resp);
		this.snackBar("Done", 3000);
	}, error => {
		console.log(error);
		this.snackBar(error, 3000);
	});

  }

  snackBar(msg: string, duration: number) {
	let snackRef = this._snackBar.open(msg, 'close', {duration});
	snackRef.onAction().subscribe(() => {
		snackRef.dismiss();
	});
  }

}
